import { render, staticRenderFns } from "./Workflows.vue?vue&type=template&id=454361f0&"
import script from "./Workflows.vue?vue&type=script&lang=ts&"
export * from "./Workflows.vue?vue&type=script&lang=ts&"
import style0 from "./Workflows.vue?vue&type=style&index=0&id=454361f0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/StratusCAD/StratusCAD/ModelPipelineClient/model-pipeline-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('454361f0')) {
      api.createRecord('454361f0', component.options)
    } else {
      api.reload('454361f0', component.options)
    }
    module.hot.accept("./Workflows.vue?vue&type=template&id=454361f0&", function () {
      api.rerender('454361f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/workflows/Workflows.vue"
export default component.exports